module.exports = __webpack_public_path__ + "static/media/2.adfc53a4.svg";